import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    formField: {
        marginRight: theme.spacing(2),
        alignItems: 'flex-start'
    },
    child: {
        flexGrow: 1
    }
});

const FormField = ({ classes, inline, width, height, flexGrow, children }) => (
    <div
        className={classes.formField}
        style={{ width, height, display: inline ? 'inline-flex' : 'flex', flexGrow }}
    >
        <div className={classes.child}>{children}</div>
    </div>
);

FormField.propTypes = {
    children: PropTypes.node.isRequired,
    inline: PropTypes.bool,
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    flexGrow: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    classes: PropTypes.objectOf(PropTypes.string).isRequired
};

FormField.defaultProps = {
    inline: false,
    height: 'auto',
    width: 200,
    flexGrow: ''
};

export default withStyles(styles, { withTheme: true })(FormField);
